import * as $ from "jquery";
/* --------------------------------------------------
 	Variables
-------------------------------------------------- */
var tasksUrl = tplUrl + "/ajax/tasks.php";

/* --------------------------------------------------
 	onReady
-------------------------------------------------- */
$(function () {
  var $main = $(".main-container");
  if ($("body").hasClass("home")) {
    if ($(".section-temoignages").length) {
      const interleaveOffset = -0.5;
      const temoignageSwiper = new Swiper(".swiper-temoignages", {
        loop: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        speed: 600,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        navigation: {
          nextEl: ".swiper-temoignages-next",
          prevEl: ".swiper-temoignages-prev",
        },
        on: {
          progress: function (swiper, progress) {
            for (var i = 0; i < swiper.slides.length; i++) {
              var slideProgress = swiper.slides[i].progress;
              var innerOffset = swiper.width * interleaveOffset;
              var innerTranslate = slideProgress * innerOffset;
              swiper.slides[i].querySelector(
                ".temoignage_container"
              ).style.transform = "translate3d(" + innerTranslate + "px, 0, 0)";
            }
          },
          touchStart: function (swiper, event) {
            for (var i = 0; i < swiper.slides.length; i++) {
              swiper.slides[i].style.transition = "";
            }
          },
          setTransition: function (swiper, speed) {
            for (var i = 0; i < swiper.slides.length; i++) {
              swiper.slides[i].style.transition = speed + "ms";
              swiper.slides[i].querySelector(
                ".temoignage_container"
              ).style.transition = speed + "ms";
            }
          },
        },
      });
    }
    setSliderImagesheight();
  }

  if ($(".swiper-page").length) {
    $(".swiper-page").each(function (index, element) {
      var $this = $(this);
      $this.addClass("instance-" + index);
      $this
        .parent()
        .find(".swiper-button-prev")
        .addClass("btn-prev-" + index);
      $this
        .parent()
        .find(".swiper-button-next")
        .addClass("btn-next-" + index);
      var swiper = new Swiper(".instance-" + index, {
        loop: true,
        navigation: {
          nextEl: $this.parent().find(".swiper-button-next")[0],
          prevEl: $this.parent().find(".swiper-button-prev")[0],
        },
      });
    });
  }

  // Toolbox
  if ($("body").hasClass("page-template-page-toolbox")) {
    // Handle click on search icon
    $(".search i").on("click", function (event) {
      $(".search form").trigger("submit");
    });

    // Handle search form submit
    $(".search form").on("submit", async function (event) {
      event.preventDefault();
      // Get input value
      const val = $('input[name="search"]').val();
      let results = [];
      await $.post(
        tasksUrl,
        {
          task: "search_in_files",
          s: val,
          post__in: filesToSearch,
        },
        function (data) {
          if (data.results) {
            results = data.results;
          }
        },
        "json"
      );

      // Add inactive class
      $(".file").addClass("inactive");
      $.each(results, function (index, value) {
        $(`.file[data-file="${value.ID}"`).removeClass("inactive");
      });
      $(".file:contains(" + val + ")").removeClass("inactive");

      // Open/close accordions
      $.each($(".section-content"), function (index, section) {
        var action;
        if ($(section).find(".file").not(".inactive").length > 0) {
          action = "open";
        } else {
          action = "close";
        }
        accordionAction(action, $(section).closest(".single-section"));
      });

      // Set number of results
      var nbResults = $(".file:not(.inactive)").length;
      if (val != "") {
        $("p.nb-results span").html(nbResults);
        $(".nb-results").show();
      } else {
        $(".nb-results").hide();
      }

      // Scroll to anchor
      if (nbResults > 0) {
        $("html, body").animate({ scrollTop: $(".content-main").offset().top });
      }
      return false;
    });
  }

  // Contact
  if ($("body").hasClass("page-template-page-contact")) {
    // Form validate
    $("form.contact-form").validate({
      submitHandler: function (form) {
        // Add a loader
        $(form).addClass("loading");
        // Remove messages
        $(form).find("p.msg").hide();
        $(form).find("p.msg").removeClass("msg-success msg-error");
        $(form).find("p.msg").empty();
        // Unbind form
        $(form).find("button").prop("disabled", true);
        // Serialize data
        // Get action URL from comment form
        var task = "submit_contact_form";
        // Ajax request
        $.ajax({
          type: "POST",
          url: tasksUrl,
          data: {
            task: task,
            inputs: $(form).serialize(),
          },
          dataType: "json",
          success: function (data) {
            if (data.success) {
              // Display success message
              $(form).find("p.msg").html("Votre message a bien été envoyé.");
              $(form).find("p.msg").addClass("msg-success");
              $(form).find("p.msg").show();
            } else {
              // Display error message
              $(form).find("p.msg").html("Une erreur est survenue.");
              $(form).find("p.msg").addClass("msg-error");
              $(form).find("p.msg").show();
              // Bind form
              $(form).find("button").prop("disabled", false);
            }
            // Remove loader
            $(form).removeClass("loading");
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            // Display error message
            $(form).find("p.msg").html("Une erreur est survenue.");
            $(form).find("p.msg").addClass("msg-error");
            $(form).find("p.msg").show();
            // Remove loader
            $(form).removeClass("loading");
            // Bind form
            $(form).find("button").prop("disabled", false);
          },
        });
      },
    });
  }

  // Accordion
  $(".accordions")
    .not(".no-slide")
    .find(".single-accordion h3.accordion-title")
    .click(function () {
      // Define animation duration
      var toggleAnimationDuration = 400;
      if ($(this).next(".section-content").find(".wysiwyg").length > 0) {
        toggleAnimationDuration = 0;
      }

      // Check section state
      if (!$(this).hasClass("active")) {
        if (!$("body").hasClass("page-template-page-toolbox")) {
          // Close open sections
          $(".single-accordion h3.accordion-title").removeClass("active");
          $(".section-content").slideUp(toggleAnimationDuration);
        }

        // Open section
        $(this).addClass("active");
        $(this).next(".section-content").slideDown(toggleAnimationDuration);
      } else {
        // Close open sections
        $(this).removeClass("active");
        $(this).next(".section-content").slideUp(toggleAnimationDuration);
      }

      return false;
    });

  // Fancybox
  $(".fancybox").fancybox({
    padding: 0,
    margin: 25,
    closeBtn: false,
    helpers: {
      title: null,
      overlay: {
        locked: false,
      },
    },
  });

  // Anchor
  $("a.anchor").click(function (e) {
    e.preventDefault();
    var href = $(this).attr("href");
    $("html, body").animate({ scrollTop: $(href).offset().top });
  });

  // Main container min-height
  setContentMinHeight();

  // Mobile menu
  $("#trigger-menu").on("click", function (event) {
    $("html").toggleClass("mobileMenuOpened");
    $("#trigger-menu").toggleClass("is-active");
  });

  // Header search
  $(".main-menu form.search-form i").click(function (event) {
    var val = $(".main-menu form.search-form input").val();
    if (val != "") {
      $(".main-menu form.search-form").submit();
    } else {
      $(".main-menu form.search-form input").trigger("focus");
    }
  });

  // Handle header search form submit
  $(".main-menu form.search-form").submit(function (event) {
    // Get input value
    var val = $(".main-menu form.search-form input").val();

    if (val) {
      // Go to search page
      val = mysql_real_escape_string(val);
      window.location = rootUrl + "?s=" + encodeURIComponent(val);
    }

    return false;
  });

  /* --------------------------------------------------
 	Plyr
  -------------------------------------------------- */
  var plyr_is_ready = false;
  var plyr_js_is_ready = false;
  var plyr_js_is_loading = false;
  var $videosIframes = $main.find(".js-plyr");
  function reinit_videos() {
    plyr_is_ready = false;
    plyr_js_is_ready = false;
    plyr_js_is_loading = false;
    $videosIframes = $main.find(".js-plyr");
    init_videos();
  }

  function init_videos() {
    if (!$videosIframes.length) return;
    video_load_plyr();
  }
  init_videos();

  function video_load_plyr() {
    if (plyr_is_ready) return;

    if (!plyr_js_is_loading) {
      plyr_js_is_loading = true;
      plyr_js_loaded();
    }
  }

  function plyr_js_loaded() {
    plyr_js_is_ready = true;
    check_plyr_is_ready();
  }

  function check_plyr_is_ready() {
    if (!plyr_is_ready && plyr_js_is_ready) {
      plyr_is_ready = true;
      init_plyr_on_video();
    }
    return plyr_is_ready;
  }

  function init_plyr_on_video() {
    $videosIframes.each(function (idx, el) {
      if ($(el).hasClass("iframe")) {
        $(el)
          .addClass("plyr__video-embed")
          .removeClass("iframe")
          .children("span")
          .remove();
      }
    });
    // https://github.com/sampotts/plyr
    var players = Plyr.setup(".main-container .js-plyr", {
      controls: [
        "play-large",
        "play",
        "progress",
        "current-time",
        "mute",
        "volume",
        "fullscreen",
      ],
    });
    $.each(players, function (idx, el) {
      if (el.elements.container) {
        var poster = $(el.elements.container)
          .closest("[data-plyr-poster]")
          .data("plyr-poster");
        if (poster) {
          el.poster = poster;
        }
      }
    });
  }
  if (tarteaucitron) {
    tarteaucitron.init({
      privacyUrl: "" /* Privacy policy url */,
      hashtag: "#tarteaucitron" /* Open the panel with this hashtag */,
      cookieName: "tarteaucitron" /* Cookie name */,
      orientation: "bottom" /* Banner position (top - bottom) */,
      showAlertSmall: false /* Show the small banner on bottom right */,
      cookieslist: false /* Show the cookie list */,
      showIcon: true /* Show cookie icon to manage cookies */,
      iconPosition:
        "BottomRight" /* BottomRight, BottomLeft, TopRight and TopLeft */,
      adblocker: false /* Show a Warning if an adblocker is detected */,
      closePopup: false /* Show a close X on the banner */,
      DenyAllCta: true /* Show the deny all button */,
      AcceptAllCta: true /* Show the accept all button when highPrivacy on */,
      highPrivacy: true /* HIGHLY RECOMMANDED Disable auto consent */,
      handleBrowserDNTRequest: false /* If Do Not Track == 1, disallow all */,
      removeCredit: true /* Remove credit link */,
      moreInfoLink: true /* Show more info link */,
      useExternalCss: true /* If false, the tarteaucitron.css file will be loaded */,
      useExternalJs: false /* If false, the tarteaucitron.js file will be loaded */,
      readmoreLink: "" /* Change the default readmore link */,
      mandatory: true /* Show a message about mandatory cookies */,
    });
    (tarteaucitron.job = tarteaucitron.job || []).push("youtube");

    $(document).on("tac.open_panel", function () {
      console.log("tac.open_panel");
    });

    var $tarteaucitronButton = $(".tarteaucitronTitle");
    $tarteaucitronButton.each(function (el, idx) {
      var $el = $(el);
      $el.text($el.text().replace(String.fromCharCode(160), ""));
    });
  }
});

/* --------------------------------------------------
 	mysql_real_escape_string
-------------------------------------------------- */

function mysql_real_escape_string(str) {
  return str.replace(/[\0\x08\x09\x1a\n\r"'\\\%]/g, function (char) {
    switch (char) {
      case "\0":
        return "\\0";
      case "\x08":
        return "\\b";
      case "\x09":
        return "\\t";
      case "\x1a":
        return "\\z";
      case "\n":
        return "\\n";
      case "\r":
        return "\\r";
      case '"':
      case "'":
      case "\\":
      case "%":
        return "\\" + char; // prepends a backslash to backslash, percent,
      // and double/single quotes
    }
  });
}

/* --------------------------------------------------
 	onScroll
-------------------------------------------------- */

window.onscroll = function () {};

/* --------------------------------------------------
 	onResize
-------------------------------------------------- */

window.onresize = function () {
  // Content min-height
  setContentMinHeight();
  setSliderImagesheight();
  setActusHeight();
};

/* --------------------------------------------------
 	Accordion function
-------------------------------------------------- */

function accordionAction(action, section) {
  if (!action || !section) {
    return;
  }

  if (action == "close") {
    $(section).find("h3.accordion-title").removeClass("active");
    $(section).find(".section-content").slideUp(400);
  } else if (action == "open") {
    $(section).find("h3.accordion-title").addClass("active");
    $(section).find(".section-content").slideDown(400);
  }
}

/* --------------------------------------------------
 	Set content min-height
-------------------------------------------------- */

function setContentMinHeight() {
  var minHeight =
    $(window).height() - $("header").height() - $("footer").height() - 100;
  if (minHeight > 0) {
    $(".main-container").css({
      "min-height": minHeight,
    });
  }
}

/* --------------------------------------------------
 	Override jQuery contains function
 	(case insensitive + accents)
-------------------------------------------------- */

jQuery.expr[":"].contains = function (a, i, m) {
  var rExps = [
    { re: /[\xC0-\xC6]/g, ch: "A" },
    { re: /[\xE0-\xE6]/g, ch: "a" },
    { re: /[\xC8-\xCB]/g, ch: "E" },
    { re: /[\xE8-\xEB]/g, ch: "e" },
    { re: /[\xCC-\xCF]/g, ch: "I" },
    { re: /[\xEC-\xEF]/g, ch: "i" },
    { re: /[\xD2-\xD6]/g, ch: "O" },
    { re: /[\xF2-\xF6]/g, ch: "o" },
    { re: /[\xD9-\xDC]/g, ch: "U" },
    { re: /[\xF9-\xFC]/g, ch: "u" },
    { re: /[\xC7-\xE7]/g, ch: "c" },
    { re: /[\xD1]/g, ch: "N" },
    { re: /[\xF1]/g, ch: "n" },
  ];

  var element = $(a).text();
  var search = m[3];

  $.each(rExps, function () {
    element = element.replace(this.re, this.ch);
    search = search.replace(this.re, this.ch);
  });

  return element.toUpperCase().indexOf(search.toUpperCase()) >= 0;
};

setSliderImagesheight();
setActusHeight();
/* --------------------------------------------------
 	Changement de taille des images dans le slider
-------------------------------------------------- */
function setSliderImagesheight() {
  if ($("body").hasClass("home")) {
    $(".slide-img-container").each(function (idx, el) {
      var $el = $(el);
      $el.css("width", $el.outerHeight());
    });
  }
}

/* --------------------------------------------------
 	Changement de taille des cards dans la grille d'actus
-------------------------------------------------- */
function setActusHeight() {
  if ($(".grid-actualites, .page_readtoo").length) {
    $(".grid-actus_actu").each(function (idx, el) {
      var $el = $(el);
      if ($el.hasClass("has-image")) {
        $el.css("height", $el.outerWidth() / 2 - 11);
      } else {
        $el.css("height", $el.outerWidth());
      }
    });
  }
}
